export default __webpack_public_path__ + "feedback-1200-c3f3faa67ebfb86f7c73cbd1db68fa1c.png";